import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg';

export default ArrowRight;
